module.exports = __webpack_public_path__ + "static/media/logo.cca2b418.png";